import { render, staticRenderFns } from "./IcoChevronRightCircle.vue?vue&type=template&id=247e6d42"
import script from "./IcoChevronRightCircle.vue?vue&type=script&lang=js"
export * from "./IcoChevronRightCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports